import { render, staticRenderFns } from "./QtdBiAisBdgd.vue?vue&type=template&id=5ab96441&"
import script from "./QtdBiAisBdgd.vue?vue&type=script&lang=js&"
export * from "./QtdBiAisBdgd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports